import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/dashboard/")({
  head: () => ({
    meta: [{ title: "Reactor | Dashboard" }],
  }),
  component: DashboardPage,
});

function DashboardPage() {
  return <Navigate to="/dashboard/progress" />;
}
